import { truncateMiddle } from '@anm/helpers/string/truncateMiddle';
import React, { useEffect, useRef, useState, FC } from 'react';
import styled, { css } from 'styled-components';

export type BreadcrumbItemProps<T = {}> = {
  id: number | string;
  name: string;
  isFirst?: boolean;
  isLast?: boolean;
  onClick?: () => void;
  freeSpace?: number;
  extraProps?: T;
  canShortImmediately?: boolean;
};

export const breadcrumbItemHoverStyle = css`
  color: var(--blue_100);
`;

const lastItem = css`
  cursor: default;
  color: ${({ theme }) => theme.textColor};
  pointer-events: none;
  &:hover {
    color: unset !important;
  }
`;

const allItems = css`
  &:hover {
    ${breadcrumbItemHoverStyle};
  }
`;

export const BreadcrumbItemWrapper = styled.p<Pick<BreadcrumbItemProps, 'isLast'>>`
  color: #919eaa;
  margin: 0;
  user-select: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 20px;
  ${({ isLast }) => (isLast ? lastItem : allItems)};
`;

const BreadcrumbItem: FC<BreadcrumbItemProps> = ({ canShortImmediately = true, ...props }) => {
  const itemRef = useRef<HTMLParagraphElement>(null);
  const { name, isLast, freeSpace } = props;
  const [itemName, setName] = useState(canShortImmediately ? truncateMiddle(name, 7, 7, 21) : name);

  useEffect(() => {
    const element = itemRef.current;
    if (!element || !freeSpace || canShortImmediately) return;

    const elementWidth = element.offsetWidth;

    if (elementWidth > freeSpace) {
      setName(truncateMiddle(name, 7, 7, 21));
    }
  }, [itemRef.current, freeSpace, canShortImmediately]);

  return (
    <BreadcrumbItemWrapper title={name} {...{ isLast }} ref={itemRef}>
      {itemName}
    </BreadcrumbItemWrapper>
  );
};

export default BreadcrumbItem;
